export default "__VITE_PUBLIC_ASSET__e6888a5a__"